module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker28-api.relevant-digital.com/"}};